import { lockScreenScroll } from '../utils/treatment';
import { showPartialsFixed } from './partialsFixed';

const btnCallForm = document.querySelectorAll('.button-call-form');
const closeFormMobile = document.querySelectorAll('.btn-close-form');
const formMain = document.querySelector('.form-main');

const formMainMobile = document.querySelector('.form-main-mobile');
const selectModelsWrapper = document.querySelectorAll("select[name=produto]");
const headerScrolled = document.querySelector('.header-fixed');


// FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
export function buttonCotationBehavior(button) {
  let buttonSelected = document.querySelectorAll(button);

  buttonSelected.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('button-product-cotation')) {
        const dataModel = btn.getAttribute("data-model");

        selectModelsWrapper.forEach((select) => {
          if  (dataModel)
            select.value = dataModel;
        });

        if (window.innerWidth >= 992) {
          if (!headerScrolled.classList.contains('show-header-scrolled')) {
            setTimeout(() => {window.scrollTo(0, 710)}, 50);
            showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
          }
        }
         
        showFixedForm();
        lockScreenScroll();

      } else {
        showFixedForm();
        lockScreenScroll();
      }
    });
  });
}

// FUNCTION TO SHOW FIXED FORM
export function showFixedForm() {
  if (window.innerWidth >= 992) {
    btnCallForm.forEach((btn) => {
      btn.innerHTML.includes('icon-fechar')
      ? btn.innerHTML = "Fale Conosco"
      : btn.innerHTML = "<i class='icon-fechar'></i>Fechar";
      
      /* btn.classList.toggle('btn-quaternary'); */
    });

    formMain.classList.toggle('form-content-fixed');
  } else {
    formMainMobile.classList.add('d-flex');
  }
}

// BUTTON TO CLOSE FORM IN MOBILE
closeFormMobile.forEach((btnClose) => {
  btnClose.addEventListener('click', () => {
    formMainMobile.classList.remove('d-flex');
    lockScreenScroll();
  });
});

// FUNCTION TO CONTROL DYNAMIC SELECTS ON PAGE CONTATOS
function toggleDynamicSelects(target) {
  let dynamicSelects = document.querySelectorAll('.dynamic');
  let buySelectDiv = document.querySelector('[data-append="options-buy"]');
  let consortiumSelectDiv = document.querySelector('[data-append="options-consortium"]');

  let buySelect = document.querySelector('[name="quero-comprar"]');
  let consortiumSelect = document.querySelector('[name="consorcio"]');

  switch (target) {
    case 'quero-comprar':
      
      dynamicSelects.forEach(select => {
        select.classList.remove('col-lg-4');
        select.classList.add('col-lg-3');
      })
      
      toggleSubSelect(buySelectDiv, buySelect, 'show');
      toggleSubSelect(consortiumSelectDiv, consortiumSelect, 'hide');
      break;

    case 'consorcio':
      
      dynamicSelects.forEach(select => {
        select.classList.remove('col-lg-4');
        select.classList.add('col-lg-3');
      })

      toggleSubSelect(consortiumSelectDiv, consortiumSelect, 'show');
      toggleSubSelect(buySelectDiv, buySelect, 'hide');
      break;

    default:
      toggleSubSelect(buySelectDiv, buySelect, 'hide');
      toggleSubSelect(consortiumSelectDiv, consortiumSelect, 'hide');
      
      dynamicSelects.forEach(select => {
        select.classList.remove('col-lg-3');
        select.classList.add('col-lg-4');
      })
  }
}

// FUNCTION TO CONTROL SELECTED DEPARTMENT ON PAGE CONTATOS
function toggleDepartmentValue(value, target) {
  let departmentInput = document.querySelector('[name="department"]');
  
  if (value == " " && target == 'quero-comprar' || value == " " && target == 'consorcio') {
    let subjectValue = document.querySelector('[name="assunto"]').value;
    departmentInput.setAttribute('value', subjectValue);
  } else {
    departmentInput.setAttribute('value', value);
  }

}

function toggleStoresShown(brand, subject) {
  let storesOptions = document.querySelectorAll('.dynamic-store');
  document.querySelector('#loja').value = "";
  document.querySelector('#area-de-sac').value = "";

  let terezaOption;
  let contornoOption;

  for (let i = 0; i < storesOptions.length; i++) {
    if (storesOptions[i].value == '24') {
      terezaOption = storesOptions[i];
    }

    if (storesOptions[i].value == '23') {
      contornoOption = storesOptions[i];
    }
  }


  let disabledAtt = 'disabled';
  let hiddenAtt = 'hidden';

  storesOptions.forEach(store => {
    let storeArr = (store.getAttribute('data-brand')).split(' ');
    let hasBrand = false;

    if (storeArr.includes(brand)) {
      hasBrand = true;
    }

    if (brand != "") {
      if (hasBrand) {
        store.removeAttribute(disabledAtt);
        store.removeAttribute(hiddenAtt);
        if (brand == "JEEP") {
          terezaOption.innerText = 'Strada Jeep Tereza';
          contornoOption.innerText = 'Strada Jeep Contorno';
        }
        if (brand == "RAM") {
          terezaOption.innerText = 'Strada Ram Tereza';
          contornoOption.innerText = 'Strada Ram Contorno';
        }
  
        if (subject == 'servicos' && brand == 'JEEP' && store.value == '23') {
          store.setAttribute(disabledAtt, '');
          store.setAttribute(hiddenAtt, '');
        }
  
        if (subject == 'sac' && brand == 'JEEP' && store.value == '23') {
          store.setAttribute('data-jeep-selected', true);
        } else {
          store.removeAttribute('data-jeep-selected');
        }
      } else {
        store.setAttribute(disabledAtt, '');
        store.setAttribute(hiddenAtt, '');
      }
    } else {
      store.removeAttribute(disabledAtt);
      store.removeAttribute(hiddenAtt);
    }

  })
}

function toggleAreasShown(store) {
  document.querySelector('#area-de-sac').value = "";
  let areas = document.querySelectorAll('#area-de-sac option');
  let isJeepContornoShown = document.querySelector('[data-jeep-selected="true"]');

  let superCenterAreas = ['pecas', 'assistencia-tecnica'];
  let jeepContornoAreas =  ['pecas', 'veiculo-usado', 'veiculo-novo', 'venda-direta'];

  let disabledAtt = 'disabled';
  let hiddenAtt = 'hidden';

  areas.forEach(area => {
    if (store == '16' && !superCenterAreas.includes(area.value)) {
      area.setAttribute(disabledAtt, '');
      area.setAttribute(hiddenAtt, '');
    } else if (isJeepContornoShown && store == '23' && !jeepContornoAreas.includes(area.value)) {
      area.setAttribute(disabledAtt, '');
      area.setAttribute(hiddenAtt, '');
    } else {
      area.removeAttribute(disabledAtt);
      area.removeAttribute(hiddenAtt);
    }
  })
}

function toggleSubSelect(targetDiv, targetSelect, event) {

  let requiredAtt = "required";

  if (event === 'hide') {
    targetDiv.classList.add('d-none');
    targetDiv.classList.remove('col-12','col-lg-3');
    targetSelect.value = "";
    targetSelect.removeAttribute('required');
  }

  if (event === 'show') {
    targetDiv.classList.remove('d-none');
    targetDiv.classList.add('col-12','col-lg-3');
    targetSelect.value = "";
    targetSelect.setAttribute(requiredAtt, "");
  }
  
}

function toggleSubInput(targetDiv, targetInput, isRequired, event) {

  let inputParent = targetDiv.getAttribute('data-append');
  let inputLabel;

  if (inputParent == 'model'){
    inputLabel = document.querySelector(`.form-${targetDiv.getAttribute('data-append')}-label`);
  }

  let requiredAtt = "required";

  if (event === 'hide') {
    targetDiv.classList.add('d-none');
    targetDiv.classList.remove('col-12','col-lg-3');
    targetInput.value = "";
    targetInput.removeAttribute('required');

    if (inputLabel && (inputLabel.innerHTML).endsWith('*')) {
      inputLabel.innerHTML = (inputLabel.innerHTML).slice(0,-1);
    }
  }

  if (event === 'show') {
    targetDiv.classList.remove('d-none');
    targetDiv.classList.add('col-12','col-lg-3');
    targetInput.value = "";

    if (isRequired  === true) {
      targetInput.setAttribute(requiredAtt, "");
      
      if (inputLabel && !(inputLabel.innerHTML).endsWith('*')) {
        inputLabel.innerHTML = (inputLabel.innerHTML + '*');
      }
    }
  }
  
}

function toggleBrandsSelect(target) {
  let brandsSelectDiv = document.querySelector('[data-append="options-brands"]');
  let brandsSelect = document.querySelector('[name="marca"]');

  let modalitiesSelectDiv = document.querySelector('[data-append="options-modalities"]');
  let modalitiesSelect = document.querySelector('[name="modalidade"]');

  let parcelsSelectDiv = document.querySelector('[data-append="options-parcels"]');
  let parcelsSelect = document.querySelector('[name="faixa-de-parcelas"]');

  let storesSelectDiv = document.querySelector('[data-append="options-stores"]');
  let storesSelect = document.querySelector('#loja');

  let areasSelectDiv = document.querySelector('[data-append="options-areas"]');
  let areasSelect = document.querySelector('[name="area-de-sac"]');

  let modelInputDiv = document.querySelector('[data-append="model"]');
  let modelInput = document.querySelector('[name="modelo"]');

  let productInputDiv = document.querySelector('[data-append="produto-de-interesse"]');
  let productInput = document.querySelector('[name="produto-de-interesse"]');

  let unitsInput = document.querySelector('#contacts-unit');
  let defaultUnit = '20';

  function resetValues() {
      brandsSelect.value = "";
      modalitiesSelect.value = "";
      parcelsSelect.value = "";
      storesSelect.value = "";
      unitsInput.value = defaultUnit;
      areasSelect.value = "";
  }

  switch (target) {
    case 'veiculos-novos':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'show');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    case 'venda-direta':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'show');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'show');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    case 'acessorios-e-boutique':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'show');
      resetValues();
      break;

    case 'pecas':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'show');
      resetValues();
      break;
    
    case 'aquisicao':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'hide');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'show');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    case 'servicos':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'show');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, true, 'show');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    case 'sac':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'show');
      toggleSubSelect(areasSelectDiv, areasSelect, 'show');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    case 'acessorios-e-boutique':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'show');
      resetValues();

    case 'pecas':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'show');
      resetValues();
    
    case 'contemplacao':
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'show');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;

    default:
      toggleSubSelect(brandsSelectDiv, brandsSelect, 'hide');
      toggleSubSelect(modalitiesSelectDiv, modalitiesSelect, 'hide');
      toggleSubSelect(parcelsSelectDiv, parcelsSelect, 'hide');
      toggleSubSelect(storesSelectDiv, storesSelect, 'hide');
      toggleSubSelect(areasSelectDiv, areasSelect, 'hide');
      toggleSubInput(modelInputDiv, modelInput, false, 'hide');
      toggleSubInput(productInputDiv, productInput, false, 'hide');
      resetValues();
      break;
  }
}

export function setCustomListener() {
  const subjectSelect = document.querySelector('[name="assunto"]');

  let buySelect = document.querySelector('[name="quero-comprar"]');
  let consortiumSelect = document.querySelector('[name="consorcio"]');

  let brandsSelect = document.querySelector('[name="marca"]');

  let storesSelect = document.querySelector('#loja');
  let unitsInput = document.querySelector('#contacts-unit');
  let defaultUnit = '20';

  if (subjectSelect) {
    subjectSelect.addEventListener('change', () => {
      toggleDynamicSelects(subjectSelect.value);
      toggleDepartmentValue(subjectSelect.value, subjectSelect.getAttribute('name'));
      toggleBrandsSelect(subjectSelect.value);
    })
  }

  if (buySelect) {
    buySelect.addEventListener('change', () => {
      toggleDepartmentValue(buySelect.value, buySelect.getAttribute('name'));
      toggleBrandsSelect(buySelect.value);
    })
  }

  if (consortiumSelect) {
    consortiumSelect.addEventListener('change', () => {
      toggleDepartmentValue(consortiumSelect.value, consortiumSelect.getAttribute('name'));
      toggleBrandsSelect(consortiumSelect.value);
    })
  }

  if (brandsSelect) {
    const brandValue = brandsSelect ? brandsSelect.value : null;
    const subjectValue = subjectSelect ? subjectSelect.value : null;

    if (brandValue !== null && subjectValue !== null) {
      toggleStoresShown(brandValue, subjectValue);
    }
  }

  if (storesSelect) {
    storesSelect.addEventListener('change', () => {
      toggleAreasShown(storesSelect.value);
      if (storesSelect.value == "") {
        unitsInput.value = defaultUnit;
      } else {
        unitsInput.value = storesSelect.value;
      }
    })
  }

}